var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.75V5.625C13.75 3.55393 12.0711 1.875 10 1.875C7.92893 1.875 6.25 3.55393 6.25 5.625V8.75M5.625 18.125H14.375C15.4105 18.125 16.25 17.2855 16.25 16.25V10.625C16.25 9.58947 15.4105 8.75 14.375 8.75H5.625C4.58947 8.75 3.75 9.58947 3.75 10.625V16.25C3.75 17.2855 4.58947 18.125 5.625 18.125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.80c6cc7b0802342a7f3a7bf3fb9cf72d.svg";
export { ForwardRef as ReactComponent };